module.exports = __webpack_public_path__ + "images/cam4-celebrity-e9f9593b3f7bcf51f5c8cf121e523c9b.png";